module.exports = [
  { text: '1D', range: 1000 * 60 * 60 * 60 * 24, window: 96, timeframe: '_15m' },
  { text: '1W', range: 1000 * 60 * 60 * 60 * 24 * 7, window: 168, timeframe: '_1h' },
  { text: '1M', range: 1000 * 60 * 60 * 60 * 24 * 7 * 30, window: 30, timeframe: '_1D' },
  { text: '1Y', range: 1000 * 60 * 60 * 60 * 24 * 7 * 30 * 365, window: 57, timeframe: '_1W' },
];
